import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function StopIncome() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [isLoading, setisLoading] = useState(false);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [name, setname] = useState("");

  const [allMember, setAllMember] = useState("");
  const [fromRegdate, setfromRegdate] = useState("");
  const [toRegdate, settoRegdate] = useState("");
  const [PlanId, setPlanId] = useState(0);
  const [topupStatus, settopupStatus] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search.slice(2),
          name: name,
          fromdate: fromDate,
          todate: toDate,
          Regfromdate: fromRegdate,
          Regtodate: toRegdate,
          topup: topupStatus,
          PlanId: PlanId,
          PageIndex: "1",
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("memberlist-->", responceRight.data.data);
      // setStakingdata(responceRight?.data?.data.records[0])
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          // id: `${item?.uid} `,
          login: (
            <>
              <a
                //href={`http://localhost:5173/AdminLogin?user_id=${item.uid}&enpass=${item?.password}`}
                href={`https://annexacapital.live/AdminLogin?user_id=${item.uid}&enpass=${item?.password}`}
                target="_blank"
                className="btn btn-lg btn-primary"
              >
                Login
              </a>
            </>
          ),
          user_id: `AC${item?.uid} `,
          ACuser_id: `AC${item?.uid}`,
          sid: `${item?.sid} `,
          email: item.email,
          mobile: item.mobile,
          ACsid: `AC${item?.sid}`,
          Waddress: `${item?.f_name} `,
          lipa: item?.ipaddress,
          RegDate: `${item?.date}`,
          PlanType: item?.PlanType,
          package: `${item?.packageamount}`,
          top_update1: item?.top_update1,
          edate: `${item?.edate} `,
          Topupstatus: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          status: item?.blockstatus,
          top_up_Stack: `${item?.top_Stack === 1 ? "Active" : "InActive"}`,
          top_up: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          top_update_Stack: item?.top_update_Stack,
          top_update: item?.top_update,
            incomestopstatus: <span className={ item?.incomestopstatus =="Start" ? "text-success" : "text-danger"}>{item?.incomestopstatus} </span>,
          staking: (
            <>
              <button
                className={`${
                  item?.incomestopstatus === "Start" ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() => Status_active(item?.uid, item?.incomestopstatus)}
              >
                {item?.incomestopstatus === "Start" ? "Stop" : "Start"} 
              </button>
            </>
          ),
          Withstatus: `${item?.withdrawl_status == 1 ? "Active" : "Block"}`,
          withstaking: (
            <>
              <button
                className={`${
                  item?.withdrawl_status === 1 ? "btn-danger" : "btn-primary"
                } btn`}
                onClick={() =>
                  Status_active_withdraw(item?.uid, item?.withdrawl_status)
                }
              >
                {item?.withdrawl_status === 1 ? "Block" : "Active"}
              </button>
            </>
          ),
          edit: (
            <>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() =>
                  navigate(`/Edit_Details?userId=${item?.user_id}`)
                }
              >
                Edit
              </button>
            </>
          ),
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const Status_active = async (id, blockstatus) => {
    try {
      console.log("statevalue", blockstatus);
      let status_value = blockstatus;
      let status = 1;

      if (status_value == "stop") {
        status = 0;
      } else {
        status = 1;
      }
      // console.log("id=>", id);
      // console.log("status=>", status);
      let res = await API?.post(
        "/ChangeIncomestatus",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Status_active_withdraw = async (id, withdrawl_status) => {
    try {
      console.log("statevalue", withdrawl_status);
      let status_value = withdrawl_status;
      let status = 1;

      if (status_value == 1) {
        status = 0;
      } else {
        status = 1;
      }
      // console.log("id=>", id);
      // console.log("status=>", status);
      let res = await API?.post(
        "/ChangeWtihdrawalStatus",

        {
          loginid: userId,
          uid: id,
          status: status,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("res_block", res);
      if ((res.data.success = "true")) {
        toast.success("Update Successfully ..");
        referral_API();
        // window.location.reload();
      } else {
        toast.error("Somthing Wrong");
      }
      console.log("MyActive", res.data.data);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/AllMemberList",
        {
          loginid: userId,
          SearchTerm: search.slice(2),
          fromdate: fromDate,
          todate: toDate,
          Regfromdate: fromRegdate,
          Regtodate: toRegdate,
          topup: topupStatus,
          PlanId: PlanId,
          PageIndex: "1",
          name: name,
          PageSize: "10000",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("memberlist-->", responceRight.data.data);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: `AC${item?.uid} `,
          SponsorId: `AC${item?.sid} `,
          Name: `${item?.f_name} `,
          email: item.email,
          mobile: item.mobile,
          RegDate: `${item?.date}`,
          Package: `${item?.packageamount}`,
          ActDate: item?.top_update1,
          Status: `${item?.top_up === 1 ? "Active" : "InActive"}`,
          BlockStatus: item?.blockstatus,
           incomestopstatus: item?.incomestopstatus,
        });
      });

      const fileName = "AllIncomestartStopRecord";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      // { Header: "Login", accessor: "login" },
      { Header: "User Id", accessor: "ACuser_id" },
      { Header: "Sponsor Id", accessor: "ACsid" },
      { Header: "Name", accessor: "Waddress" },
      { Header: "Email", accessor: "email" },
      { Header: "mobile", accessor: "mobile" },
      { Header: "Reg. Date", accessor: "RegDate" },
      { Header: "Act. Status", accessor: "Topupstatus" },
      // { Header: "Activation Amount", accessor: "package" },
      { Header: "Activation Date", accessor: "top_update1" },
       { Header: "Start/Stop Income Status", accessor: "incomestopstatus" },
      { Header: "Action", accessor: "staking" },
      // { Header: "Withdrawl Status", accessor: "Withstatus" },
      // { Header: "Withdrawl Action", accessor: "withstaking" },
      // { Header: "Edit", accessor: "edit" },
    ],
  });

  // if (isLoading) return <Spinner />;

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Stop/Start Income</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <label>User Id</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        id="uid"
                        onChange={(e) => setSearch(e.target.value)}
                        name="uid"
                        placeholder="Search By User Id"
                        type="text"
                        value={search}
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Name/email/mobile</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        id="name"
                        onChange={(e) => setname(e.target.value)}
                        name="name"
                        placeholder="Search By Name,email,mobile"
                        type="text"
                        value={name}
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Registration From</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setfromRegdate(e.target.value)}
                        value={fromRegdate}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Registration To</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        value={toRegdate}
                        onChange={(e) => settoRegdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Actvation From</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromDate(e.target.value)}
                        value={fromDate}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Actvation To</label>
                      <br />
                      <input
                        class="form-control in-ip-1"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-1">
                      <label>Status</label>
                      <br />
                      <select
                        name="Position"
                        className="form-control"
                        onChange={(e) => settopupStatus(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    <div class="col-md-1">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-1">
                      <br />
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div>
                        <div className="col-md-12">
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default StopIncome;
